module.exports = __webpack_public_path__ + "img/744.4ad65ee0.jpg";